import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';

import { estruturasModuleName } from "../../shared/data.service";
import { divisoesModuleName, divisoesStorage } from "../shared/data.service";
import { Divisao } from "../shared/divisao.model";
import { DivisaoNavigationService } from "../shared/divisao-navigation.service";
import { DivisaoApiService } from "../shared/divisao-api.service";
import { UtilService } from "../../../shared/services/util.service";
import { AutoCompleteService } from "../../../shared/components/autocomplete/autocomplete.service";
import {editRoute, newRoute, newRouteFemale} from "../../../shared/services/data.service";
import { AreaApiService } from "../../areas/shared/area-api.service";
import {Area} from "../../areas/shared/area.model";
import {DivisoesService} from "../shared/divisao.service";
import {areasStorage, areasQuery} from "../../areas/shared/data.service";
import {AreaNavigationService} from "../../areas/shared/area-navigation.service";

@Component({
  template: require('./divisao-form.component.html'),
  styles: [require('./divisao-form.component.css')]
})
export class DivisaoFormComponent implements OnInit {
  estruturasModule: any = estruturasModuleName;
  divisoesModule: any = divisoesModuleName;
  formObject: any = new Divisao();
  areaObject: any = new Area();
  actionTitle: string;
  submitted: boolean = false;
  btnSaveDisabled: boolean = false;

  areaSelectId: string = 'area';
  areasQuery: any = areasQuery;

  form: FormGroup;
  divisao = new FormControl('', Validators.required);
  area = new FormControl('');
  ativo = new FormControl('');

  private returnToOtherForm: boolean = false;
  private otherForm: string;
  private responseDivisao: any;

  constructor(
    private _route: ActivatedRoute,
    private _divisaoNavigationService: DivisaoNavigationService,
    private _divisaoApiService: DivisaoApiService,
    private _divisoesService: DivisoesService,
    private _areaApiService: AreaApiService,
    private _areaNavigationService: AreaNavigationService,
    private _utilService: UtilService,
    private _autocompleteService: AutoCompleteService,
    private _fb: FormBuilder
  ) {
    this.form = _fb.group({
      ativo: this.ativo,
      divisao: this.divisao,
      area: this.area
    });
  }

  ngOnInit() {
    this.isNewAutoComplete();
  }

  clickGoToList() {
    this.goToList();
  }

  clickCancel() {
    this.toLeaveHere();
  }

  onSubmit(evt: any) {
    this.submitted = true;
    if(evt.valid) {
      this.btnSaveDisabled = true;
      var object:Divisao = this._utilService.cloneObject(this.formObject);

      if (this.areaObject.id) {
        object.areaId = this.areaObject.id;
      } else {
        this.btnSaveDisabled = false;
        return false;
      }

      if (this.formObject.id) {
        this.onEditDivisao(object);
      } else {
        this.onAddDivisao(object);
      }
    }
  }

  getAreasObject(object: any) {
    if(object.novo) {
      var thisFormObject: any = this.formObject;
      thisFormObject.area = this.areaObject;

      this._divisoesService.setSessionStorage(thisFormObject);

      var toOtherFormObject: any = {
        nome: object.text,
        form: divisoesStorage
      };
      this._autocompleteService.setSessionStorage(toOtherFormObject, areasStorage);
      this._areaNavigationService.goToNew();
    } else {
      this.areaObject = object;
      this._utilService.setSelectOnFormControl(this.form, 'area', object);
    }
  }

  private onAddDivisao(object: Divisao) {
    this._divisaoApiService.onPost(object, this.onDone);
  }

  private onEditDivisao(object: Divisao) {
    this._divisaoApiService.onPut(object, this.onDone);
  }

  private onDone = (function (Response: any) {
    if (!Response.error)  {
      this.responseDivisao = Response;
      if (this.formObject.id) {
        this._utilService.swalMessageEditSuccess();
      } else {
        this._utilService.swalMessageAddSuccess();
      }

      this.toLeaveHere();
    } else {
      this.btnSaveDisabled = false;
      this._utilService.swalMessageWarningCustom(Response.error);
    }
  }.bind(this));

  private getObject(id: number) {
    var onDone = (function(Response: any) {
      if (!Response.error)  {
        this.formObject = Response;
        this.setModelToForm();

      } else {
        this._utilService.swalMessageWarningCustom('Nenhuma divisão encontrada com este id.');
        this.toLeaveHere();
      }
    }.bind(this));

    this._divisaoApiService.onGetById(id, onDone);
  }

  private testSession() {
    var id: number;
    var session: any = this._divisoesService.getSessionStorage();
    this._divisoesService.clearSessionStorage();

    if (session) {
      this.formObject = session;
      id = session.id;
      this.setModelToForm();
    } else {
      id = +this._route.snapshot.params['id'];
      if (id) {
        this.setEditNormal(id);
      } else {
        this.setNewNormal();
      }
    }

    this.setActionTitle(id);
  }

  private setActionTitle(id: number) {
    if (id) {
      this.actionTitle = editRoute;
    } else {
      this.actionTitle = newRouteFemale;
    }
  }

  private setEditNormal(id: number) {
    this.getObject(id);
  }

  private setNewNormal() {
    //se tiver alguma configuração inicial de um cadastro novo
  }

  private setEditSession() {
    //qndo retornou para continuar a edição
  }

  private setNewSession() {
    //qndo retornou para continuar o cadastro
  }

  private isNewAutoComplete() {
    var newAutoComplete: any = this._autocompleteService.getSessionStorage(divisoesStorage);
    if (newAutoComplete) {
      this.returnToOtherForm = true;
      this.otherForm = newAutoComplete.form;
      this.formObject.divisao = newAutoComplete.divisao;

      this.setActionTitle(this.formObject.id);
    } else {
      //retornando de um cadastro
      this.testSession();
    }
  }

  private setModelToForm() {

    if (this.formObject.area) {
      this.areaObject = this._utilService.cloneObject(this.formObject.area);
      delete this.formObject['area'];

      var selectObject:any = {text: this.areaObject.nome, id: this.areaObject.id};

      this._autocompleteService.createOptionOnSelect2(this.areaSelectId, selectObject);
      this._autocompleteService.setValueOnSelect2(selectObject.id, this.areaSelectId);
      this._utilService.setSelectOnFormControl(this.form, 'area', this.areaObject);
    }
  }

  private goToList() {
    this._divisaoNavigationService.goToList();
  }

  private toLeaveHere() {
    if (this.returnToOtherForm) {
      this._divisoesService.returnToOtherForm(this.otherForm, this.responseDivisao);
    } else {
      this.goToList();
    }
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/divisoes/divisao-form/divisao-form.component.ts
 **/